'use client';
import { useEffect } from 'react';

export default function ClientImportComponent() {
  useEffect(() => {
    import('swiper/css');
    import('swiper/css/navigation');
    import('swiper/css/pagination');
  }, []);

  return null;
}
